var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "translate(0 -61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11338",
    "data-name": "Group 11338",
    transform: "translate(0 61)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1838",
    "data-name": "Path 1838",
    d: "M18.242,61H1.758A1.807,1.807,0,0,0,0,62.846V75.154A1.807,1.807,0,0,0,1.758,77H18.242A1.806,1.806,0,0,0,20,75.154V62.846A1.807,1.807,0,0,0,18.242,61ZM18,62.231l-7.962,8.362L2.006,62.231ZM1.172,74.9V63.1l5.644,5.877Zm.829.87,5.647-5.931L9.627,71.9a.566.566,0,0,0,.827,0l1.929-2.026L18,75.769Zm16.828-.87L13.211,69l5.617-5.9Z",
    transform: "translate(0 -61)",
    fill: "#74613C "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.247186ab7a0ba2423989baf7c3b78d5d.svg";
export { ForwardRef as ReactComponent };